var _path, _path2, _style;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackToTop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    style: {},
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M83.0234 74.6016L60.807 57.6908C60.2048 57.2324 59.3686 57.2396 58.7743 57.7084L37.36 74.6016",
    stroke: "white",
    strokeWidth: 5,
    strokeLinecap: "round",
    className: "aNiGpCen_1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M83.0234 62.1016L60.807 45.1908C60.2048 44.7324 59.3686 44.7396 58.7743 45.2084L37.36 62.1016",
    stroke: "white",
    strokeWidth: 5,
    strokeLinecap: "round",
    className: "aNiGpCen_2"
  })), _style || (_style = /*#__PURE__*/React.createElement("style", {
    "data-made-with": "vivus-instant"
  }, ".aNiGpCen_0{strokeDasharray:353 355;stroke-dashoffset:354;animation:aNiGpCen_draw_0 2700ms ease-in-out 0ms infinite,aNiGpCen_fade 2700ms linear 0ms infinite;}.aNiGpCen_1{strokeDasharray:58 60;stroke-dashoffset:59;animation:aNiGpCen_draw_1 2700ms ease-in-out 0ms infinite,aNiGpCen_fade 2700ms linear 0ms infinite;}.aNiGpCen_2{strokeDasharray:58 60;stroke-dashoffset:59;animation:aNiGpCen_draw_2 2700ms ease-in-out 0ms infinite,aNiGpCen_fade 2700ms linear 0ms infinite;}@keyframes aNiGpCen_draw{100%{stroke-dashoffset:0;}}@keyframes aNiGpCen_fade{0%{stroke-opacity:1;}85.18518518518519%{stroke-opacity:1;}100%{stroke-opacity:0;}}@keyframes aNiGpCen_draw_0{3.7037037037037033%{stroke-dashoffset: 354}28.395061728395067%{ stroke-dashoffset: 0;}100%{ stroke-dashoffset: 0;}}@keyframes aNiGpCen_draw_1{9.87654320987654%{stroke-dashoffset: 59}34.567901234567906%{ stroke-dashoffset: 0;}100%{ stroke-dashoffset: 0;}}@keyframes aNiGpCen_draw_2{16.049382716049383%{stroke-dashoffset: 59}40.74074074074074%{ stroke-dashoffset: 0;}100%{ stroke-dashoffset: 0;}}")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackToTop);
export default __webpack_public_path__ + "static/media/BackToTop.07aca5e051b2b70770ea4f601d2cdb93.svg";
export { ForwardRef as ReactComponent };